import CryptoJS from 'crypto-js';

const USER_INFO = '__videai_user_info__';

export const setUserToken = (userInfo: API.Users) => {
  localStorage.setItem(USER_INFO, JSON.stringify(userInfo));
};
export const logout = () => {
  localStorage.removeItem(USER_INFO);
};

export const getUserToken = (): API.Users | null => {
  const userInfo = localStorage.getItem(USER_INFO);
  return userInfo ? JSON.parse(userInfo) : null;
};

export const getLoginToken = (timestamp: string) => {
  const u = getUserToken();
  if (!u) {
    return null;
  }
  const { token = '', hash = '' } = u;
  const enCode = token + hash + timestamp + hash + token;
  const md5Hash = CryptoJS.MD5(enCode).toString();
  return md5Hash;
};
export const getHeaderAuthorization = () => {
  if (!getUserToken()) {
    return null;
  }
  const { id = '' } = getUserToken()!;
  const timestamp = Date.now().toString() || '';
  const token = getLoginToken(timestamp) || '';
  return {
    userId: id,
    token,
    timestamp,
  };
};
